import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

export default class Head extends PureComponent {
  static propTypes = {
    canonicalUrl: PropTypes.string,
    title: PropTypes.string,
    robots: PropTypes.string,
    description: PropTypes.string,
  };

  render() {
    const { canonicalUrl, title, robots, description } = this.props;

    return (
      <Helmet>
        {title ? <title>{title}</title> : null}
        {description ? <meta name="description" content={description} /> : null}
        {robots ? <meta name="robots" content={robots} /> : null}
        {canonicalUrl ? <link rel="canonical" href={canonicalUrl} /> : null}
        <meta charSet="utf-8" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, user-scalable=no"
        />
        <link rel="shortcut icon" href="/favicon.ico" />
      </Helmet>
    );
  }
}
